<template>
    <div v-show="visible">
        <el-dialog
            title="退款"
            :close-on-click-modal="false"
            :visible.sync="visible"
            width="480px"
            :before-close="dialogClose">
            <el-form ref="form" :model="form" :rules="rules" label-width="90px">
                <el-form-item label="订单号">
                    <el-input v-model="form.orderId" readonly></el-input>
                </el-form-item>
                <el-form-item label="退款原因">
                    <el-input
                        v-model="form.lastRefundReason"
                        type="textarea"
                        :rows="4"
                        readonly>
                    </el-input>
                </el-form-item>
                <el-form-item label="退款金额" prop="amount">
                    <el-input-number
                        v-model="form.amount"
                        :precision="2"
                        :min="0"
                        :controls="false"
                        placeholder="请输入退款金额"
                        style="width:100%;">
                    </el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible = false">取 消</el-button>
                <el-button type="primary" :loading="saving" @click="onConfirm">确 认</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import http from '../../../../common/http';

export default {
    mixins: [http],
    data() {
        return {
            visible: false,
            saving: false,
            onSuccess: null,
            form: {
                orderId: '',
                amount: null,
                lastRefundReason: ''
            },
            rules: {
                amount: [
                    { required: true, message: '请输入退款金额', trigger: 'blur' }
                ]
            }
        };
    },
    methods: {
        init(row, onSuccess) {
            this.visible = true;
            this.onSuccess = onSuccess;
            this.form.orderId = row.orderId || '';
            this.form.amount = null;
            this.form.lastRefundReason = row.lastRefundReason || '';
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.clearValidate();
                }
            });
        },
        onConfirm() {
            this.$refs.form.validate((valid) => {
                if (!valid) {
                    return;
                }
                const msg = '确认对该订单发起退款吗？';
                this.$commonFn.showConfirm2(msg, () => {
                    this.submitRefund();
                });
            });
        },
        submitRefund() {
            this.saving = true;
            const url = this.memberOrderRefundUrl;
            const data = {
                orderId: this.form.orderId,
                amount: this.form.amount
            };
            this.apiPost(url, data).then((res) => {
                this.saving = false;
                if (res.status === 200) {
                    this.$commonFn.showTip(res.message, 1);
                    this.visible = false;
                    if (typeof this.onSuccess === 'function') {
                        this.onSuccess();
                    }
                } else {
                    this.$commonFn.showTip(res.message, 3);
                }
            }, (err) => {
                console.log(err);
                this.saving = false;
            });
        },
        dialogClose(done) {
            done();
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/page/member/order/OrderRefund.vue